import styled from "styled-components";
import { ComponentType, SVGProps } from "react";

// Accept either a React component or an intrinsic HTML element (e.g., div, span, svg)
export const StyledIcon = (Icon: ComponentType<SVGProps<SVGSVGElement>> | keyof JSX.IntrinsicElements) => {
  return styled(Icon)`
    display: block;
    margin: 1.5rem auto 0.75rem;
    width: 86px;
    height: auto;
  `;
};
